import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { IntlContext } from "context";
import Login from "./Login";
import Button from "ui/Button";
import { buildRoute, REGISTER_STEPS, ROUTES } from "routes";

const OurServicesLoginOrSignup: React.FC = () => {
    const intl = useContext(IntlContext);
    const { id } = useParams();
    const navigate = useNavigate();

    const goBack = () => {
        navigate(id ? buildRoute.provider(String(id)) : ROUTES.HOME);
    };

    return (
        <div className="our_services">
            <div className="container view_container">
                <Button className="btn btn--yellow btn--square margin-bottom--4" onClick={goBack}>
                    {intl.formatMessage("generic.action.back")}
                </Button>
                <div className="our_services_view_container">
                    <div className="grid--2 grid--medium-1 grid--small-1 grid--has-gutter-3x">
                        <div className="container_form_intermediate_page">
                            <Login serviceId={id} />
                        </div>
                        <div className="container_form_intermediate_page">
                            <h3 className="flex flex--align-items-center flex--justify-content-center padding-top--3">
                                {intl.formatMessage("our_services.form.label.dont_have_account")}
                            </h3>
                            <div className="flex flex--align-items-center flex--justify-content-center margin-top--2 margin-bottom--2">
                                <Link
                                    to={buildRoute.registerSub(REGISTER_STEPS.USER)}
                                    className="btn btn--primary btn--default margin-top--4"
                                >
                                    {intl.formatMessage("register.client.create")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurServicesLoginOrSignup;
